import React from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router-dom';

import { IRoute } from 'config/routes';

import Page404Trigger from 'app-shell/Page404Container/Page404Trigger';

export interface IRoutesProps<TInjectedProps = {}> {
  items: IRoute[];
  injectedProps?: TInjectedProps;
}

function renderRoute<TInjectedProps>(route: IRoute, injectedProps?: TInjectedProps) {
  const render = (props: RouteComponentProps) => (
    <route.component {...props} {...injectedProps} routes={route.routes} />
  );

  return <Route key={route.path} exact={route.exact || false} path={route.path} render={render} />;
}

export default function Routes<TInjectedProps = {}>(props: IRoutesProps<TInjectedProps>) {
  return (
    <Switch>
      {props.items.map((route) => renderRoute<TInjectedProps>(route, props.injectedProps))}
      <Route>
        <Page404Trigger />
      </Route>
    </Switch>
  );
}
